import React, { PureComponent } from "react";
import { Icon, Tooltip, Drawer, Button, notification, DatePicker } from "antd";
import { Link } from "react-router-dom";
import { debounce } from "lodash-decorators";
import styles from "./index.less";
import RightContent from "./RightContent";
import Request, { MEDIA_URL } from "../../request";
import ListFollowUps from "../_utils/listInvoiceFollowUp";
import ListStudentFollowUp from "../_utils/listFollowUp";
import { TableComp } from "sz-react-utils";
import _ from 'lodash';
import {
  FaCalendarPlus,
  FaFistRaised,
  FaClipboardList,
  FaDesktop,
  FaPlaneDeparture,
  FaFileAlt,
  FaUserPlus,
  FaUserGraduate,
  FaRegFileExcel,
  FaArchive,
  FaBookDead,
  FaPlusCircle,
  FaPollH,
  FaUserTimes
} from "react-icons/fa";

import { RightsWrapper } from "../_utils/utils";
import userRights from "../_utils/userRights";

import PendingConsultancyFollowups from "../_utils/pendingConsultancyFollowups";
import moment from "moment";
import PDFFileView from "../DocumentViews/PDFFileView";
import WithdrawRequestsListDrawer from "../Invoice/withdrawRequestsListDrawer";
import InvoiceApprovalDrawer from "../drawers/invoiceApprovalDrawer";
import InquiryReviewDrawer from "../drawers/inquiryReviewDrawer";
import LatestFollowup from "../_utils/latestFollowup";
import MoveToClaimRequestDrawer from "../drawers/moveToClaimRequestDrawer";
import BranchPaidInvoiceDrawer from "../drawers/branchPaidInvoiceDrawer";
import AddInquiryModal from '../modals/inquiry/index';

let currentUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
const compantDetail = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')) : null;
const dateFormat = compantDetail && compantDetail.dateFormat ? compantDetail.dateFormat : 'DD.MM.YYYY';
const link = {
  "Front Desk": '/desk/update-counselling',
  "Registration Desk": "/registration/fees",
  "Application Desk": "/desk/allApplication-desk/update",
  "Visa Desk": "/desk/getVisa",
  "Claim Desk": "/desk/getClaim"
}
let studentObj = {};

export default class GlobalHeader extends PureComponent {
  state = {
    openApplicationDrawar: false,
    totalNewFiles: 0,
    newFilesData: [],
    totalNewIncentiveFiles: 0,
    newIncentivesFilesData: [],
    openIncentiveInvoiceDrawer: false,
    showPaymentFollowupDrawer: false,
    totalPaymentFollowUpsData: [],
    totalPaymentFollowUps: 0,
    showFollowUp: false,
    invoiceObj: null,
    newMoveArchiveRequestsData: [],
    totalNewMoveArchiveRequest: 0,
    openMoveToArchiveDeskDrawer: false,
    totalUpdationRequests: 0,
    paymentUpdationsData: [],
    openUpdatePaymentDrawer: false,
    showBranchInvoiceStatusDrawer: false,
    branchInvoiceDetails: [],
    ext: null,
    linkUrl: null,
    branchInvoice: [],
    annoucementData: [],
    totalAnnoucements: 0,
    showAnnoucmentDrawer: false,
    showDueInvoicesDrawer: false,
    dueInvoicesList: [],
    openWithDrawStudentDrawer: false,
    showReviewDrawer: false,
    inquiryDetail: {},
    branchInvoiceLoading: {},
    showStudentFollowUp: false,
    openClaimRequestDrawer: false,
    openInvoiceApprovalRequestDrawer: false,
    showPaidBranchInvoiceDrawer: false,
    showInquiryModal: false
  };
  componentWillUnmount() {
    this.triggerResizeEvent.cancel();
  }


  checkUrlExt = (url) => {
    return url.split(/[#?]/)[0].split('.').pop().trim();
  }

  viewPDF = (branchInvoice) => {
    if (branchInvoice.length > 0) {
      let linkUrl = MEDIA_URL + branchInvoice[0].url;
      let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
      if (this.checkUrlExt(linkUrl)) {
        this.setState({ ext: ext, linkUrl: linkUrl, branchInvoice: branchInvoice });
      } else {
        notification.warning({
          message: 'File  not exists!!!.'
        })
      }
    }
  }

  viewBranchInvoice = (branchInvoice) => {
    let linkUrl = MEDIA_URL + branchInvoice;
    let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
    if (this.checkUrlExt(linkUrl)) {
      this.setState({ ext: ext, linkUrl: linkUrl, branchInvoice: branchInvoice });
    } else {
      notification.warning({
        message: 'File  not exists!!!.'
      })
    }

  }

  closePDFDocument = () => {
    this.setState({ ext: null, linkUrl: null, branchInvoice: [] });
  }

  openStudenFollowUps = (record) => {
    studentObj = {
      arr: record.followUp,
      name: record.studentName,
      rating: record.counsellingDesk.rating,
      subRating: record.counsellingDesk.subRating,
      _id: record._id,
    };
    this.setState({ showStudentFollowUp: true });
  };

  closeStudentFollowUp = () => {
    this.setState({ showStudentFollowUp: false }, () => {
      this.getNewFiles();
    })
  }




  componentDidMount() {
    const { collapsed, onCollapse } = this.props;
    let collapsedMenu = localStorage.getItem('menuCollapsed');
    if (collapsedMenu == 'false') {
      onCollapse(true);
    }



    if (userRights.checkRights('newFileNotification.view')) {
      setInterval(() => {
        this.getNewFiles();
      }, 30000);
    }

    if (userRights.checkRights('moveClaimRequestNotification.view')) {
      setInterval(() => {
        this.getMoveToClaimRequest();
        // this.getNewFiles();
      }, 60000);
    }

    if (userRights.checkRights('newIncentiveInvoiceNotification.view')) {
      setInterval(() => {
        this.getNewIncentiveInvoices()
      }, 60000)
    }

    if (userRights.checkRights('showInvoicePaymentFollowUp.view')) {
      setInterval(() => {
        this.getPaymentFollowUps()
      }, 60000)
    }

    if (userRights.checkRights('moveToArchiveDeskNotification.view')) {
      setInterval(() => {
        this.getMoveToArchiveDesk()
      }, 60000)
    }

    if (userRights.checkRights('financeWithdrawDesk.view')) {
      setInterval(() => {
        this.getWithdrawnRequests()
      }, 30 * 60 * 1000)
    }

    if (userRights.checkRights('finalInvoiceApprovalRequest.view')) {
      setInterval(() => {
        this.getInvoiceApprovalRequest();
        // this.getNewFiles();
      }, 60000);
    }


    if (userRights.checkRights('accountPaymentUpdateRequests.view')) {
      setInterval(() => {
        this.getPaymentUpdationRequests();
      }, 40000);
    }


    // if (userRights.checkRights('viewBranchUploadedInvoice.view')) {
    //   setInterval(() => {
    //     this.getApBranchInvoicesData();
    //   }, 60000)
    // }

    setInterval(() => {
      this.getUnreadAnnoucements();
    }, 60000)

    if (currentUser && currentUser.isBranchHead) {
      setInterval(() => {
        this.getPaidBranchInvoices();
      }, 60000)
    }





    let dueInvoiceInterval = null;

    // inside your header component
    if (userRights.checkRights('dueInvoicesNotification.view')) {
      if (!dueInvoiceInterval) {
        dueInvoiceInterval = setInterval(() => {
          this.getDueInvoicesList();
        }, 60000);
      }
    }
  }


  getInvoiceDueMoment = (record) => {
    if (
      !record ||
      !record.nextInvoiceGenerationDates ||
      !record.nextInvoiceGenerationDates.length
    ) {
      return null;
    }

    const todayEnd = moment().endOf('day');

    for (let i = 0; i < record.nextInvoiceGenerationDates.length; i++) {
      const item = record.nextInvoiceGenerationDates[i];

      if (item.withdrawRequest === true) continue;

      const genDate = this.parseMongoDate(item.generationDate);
      if (!genDate || !genDate.isValid()) continue;

      // CASE 1: Not generated but due
      if (
        item.invoiceGenerated === false &&
        genDate.isSameOrBefore(todayEnd)
      ) {
        return genDate;
      }

      // CASE 2: Generated PI-TP / GPI-TP
      if (
        item.invoiceGenerated === true &&
        item.invoiceGeneratedNumber &&
        /^(PI-TP|GPI-TP)/.test(item.invoiceGeneratedNumber) &&
        genDate.isSameOrBefore(todayEnd)
      ) {
        return genDate;
      }
    }

    return null;
  };




  getPaymentFollowUps = async (params) => {
    const res = await Request.fetchTodayPaymentFollowups({})
    if (res.total > 0) {
      this.setState({ showPaymentFollowupDrawer: true })
    } else {
      this.setState({ showPaymentFollowupDrawer: false })
    }
    this.setState({ totalPaymentFollowUps: res.total, totalPaymentFollowUpsData: res.data });
  }


  getMoveToArchiveDesk = async (params) => {
    const res = await Request.fetchMoveToArchiveDeskRequests({})
    if (res.total > 0) {
      this.setState({ openMoveToArchiveDeskDrawer: true })
    } else {
      this.setState({ openMoveToArchiveDeskDrawer: false })
    }
    this.setState({ totalNewMoveArchiveRequest: res.total, newMoveArchiveRequestsData: res.data });
  }

  getWithdrawnRequests = async (params) => {
    const res = await Request.getInvoiceWithdrawRequests({});

    if (res.total > 0) {
      this.setState({ openWithDrawStudentDrawer: true });
    }
  }

  getInvoiceApprovalRequest = async (params) => {
    const res = await Request.getInvoiceApprovalRequestCount({});
    if (res.total > 0) {
      this.setState({ openInvoiceApprovalRequestDrawer: true });
    }
  }

  closeInvoiceApprovalRequest = async () => {
    this.setState({ openInvoiceApprovalRequestDrawer: false });
  }

  closeWithdrawRequestDrawer = () => {
    this.setState({ openWithDrawStudentDrawer: false })
  }

  closeClaimRequestDrawer = () => {
    this.setState({ openClaimRequestDrawer: false })
  }


  getNewIncentiveInvoices = async (params) => {
    const res = await Request.fetchNewIncentiveInvoices({})
    if (res.total > 0) {
      this.setState({ openIncentiveInvoiceDrawer: true })
    } else {
      this.setState({ openIncentiveInvoiceDrawer: false })
    }
    this.setState({ totalNewIncentiveFiles: res.total, newIncentivesFilesData: res.data });
  }

  getNewFiles = async (params) => {
    const res = await Request.fetchNewFiles({});
    if (res.total > 0) {
      this.setState({ openApplicationDrawar: true });
    } else {
      this.setState({ openApplicationDrawar: false });
    }
    this.setState({ totalNewFiles: res.total, newFilesData: res.data });
  }

  getMoveToClaimRequest = async (params) => {
    const res = await Request.getMoveToClaimRequest({});
    if (res.total > 0) {
      this.setState({ openClaimRequestDrawer: true });
    } else {
      this.setState({ openClaimRequestDrawer: false });
    }
  }

  getPaymentUpdationRequests = async (params) => {
    const res = await Request.fetchPendingPaymentUpdateRequest(params);
    if (res.total > 0) {
      this.setState({ openUpdatePaymentDrawer: true });
    } else {
      this.setState({ openUpdatePaymentDrawer: false });
    }
    this.setState({ totalUpdationRequests: res.total, paymentUpdationsData: res.data });
  }


  getUnreadAnnoucements = async (params) => {
    const res = await Request.getUnreadAnnoucements(params);
    if (res.total > 0) {
      this.setState({ showAnnoucmentDrawer: true, totalAnnoucements: res.total, annoucementData: res.data });
    } else {
      this.setState({ showAnnoucmentDrawer: false });
    }
  }

  getPaidBranchInvoices = async (params) => {
    const res = await Request.getPaidBranchInvoiceCount(params);
    if (res.total > 0) {
      this.setState({ showPaidBranchInvoiceDrawer: true })
    } else {
      this.setState({ showPaidBranchInvoiceDrawer: false });
    }
  }

  closePaidBranchInvoiceDrawer = () => {
    this.setState({ showPaidBranchInvoiceDrawer: false })
  }

  getApBranchInvoicesData = async (params) => {
    const res = await Request.getApBranchInvoicesData(params);
    if (res.total > 0) {
      let branchInvoiceLoading = {};

      _.each(res.data, (item) => {
        branchInvoiceLoading[item.invoiceNumber] = false;
      });
      this.setState({ showBranchInvoiceStatusDrawer: true, branchInvoiceDetails: res.data, branchInvoiceLoading });
    } else {
      this.setState({ showBranchInvoiceStatusDrawer: false, branchInvoiceDetails: [] });
    }
  }


  // getDueInvoicesList = async (params) => {
  //   const res = await Request.getDueInvoiceList(params);
  //   if (res.total > 0) {
  //     this.setState({ showDueInvoicesDrawer: true, dueInvoicesList: res.data });
  //   } else {
  //     this.setState({ showDueInvoicesDrawer: false, dueInvoicesList: [] });
  //   }
  // }

  getDueInvoicesList = async (params) => {
    try {
      const res = await Request.getDueInvoiceList(params);

      if (res && res.total > 0) {
        this.setState({
          showDueInvoicesDrawer: true,
          dueInvoicesList: res.data,
          filteredDueInvoicesList: res.data   // 👈 INITIAL SAME
        });
      } else {
        this.setState({
          showDueInvoicesDrawer: false,
          dueInvoicesList: [],
          filteredDueInvoicesList: []
        });
      }
    } catch (err) {
      console.error('Error fetching due invoices', err);
    }
  };


  @debounce(600)
  triggerResizeEvent() {
    const event = document.createEvent("HTMLEvents");
    event.initEvent("resize", true, false);
    window.dispatchEvent(event);
  }

  toggle = () => {
    const { collapsed, onCollapse } = this.props;
    let collapsedMenu = collapsed ? false : true;
    localStorage.setItem('menuCollapsed', collapsedMenu);
    onCollapse(collapsedMenu);
    this.triggerResizeEvent();
  };

  constructor(props) {
    super(props)
    this.tableOverallReport = React.createRef();
    this.tableIncentiveReport = React.createRef();
    this.tableInvoiceFollowUp = React.createRef();
    this.tableArchiveRequests = React.createRef();
    this.updatePaymentRequests = React.createRef();
    this.branchPaymentStatusDrawer = React.createRef();
    this.annoucmentsDrawer = React.createRef();
    this.dueInvoicesDrawer = React.createRef();
  }

  approveApplication = async (recordId) => {
    const response = await Request.approveApplication({ recordId });
    if (response.success) {
      notification.success({
        message: 'Application approved successfully',
      });
      this.getNewFiles();
    } else {
      notification.warning({
        message: 'Something wrong, Please try after sometime',
      })
    }
  }


  approveMoveArchiveRequest = async (recordId) => {
    const response = await Request.approveMoveArchiveRequest({ recordId })
    if (response.success) {
      notification.success({
        message: response.message
      })
      this.getMoveToArchiveDesk()
    } else {
      notification.error({
        message: response.message
      })
    }
  }
  rejectMoveArchiveRequest = async (recordId) => {
    let reason = prompt('Rejection Reason');
    if (!reason) {
      notification.error({
        message: 'Please Provide Rejection Reason'
      });
    }
    const response = await Request.rejectMoveArchiveRequest({ recordId, reason })
    if (response.success) {
      notification.success({
        message: response.message
      })
      this.getMoveToArchiveDesk()
    } else {
      notification.error({
        message: response.message
      })
    }
  }

  openFollowUps = (record) => {
    let invoiceObj = {
      invoiceToName: record.invoiceToName,
      invoiceToEmail: record.invoiceToEmail,
      _id: record._id,
    };
    this.setState({ showFollowUp: true, invoiceObj });
  };

  closeFollowUp = () => {
    this.setState({
      showFollowUp: false,
      invoiceObj: null,
    }, () => {
      this.getPaymentFollowUps()
    });
  };

  acceptIncentiveInvoice = async (recordId) => {
    const response = await Request.acceptIncentiveInvoice({ recordId })
    if (response.success) {
      notification.success({
        message: response.message,
      })
      this.getNewIncentiveInvoices()
    } else {
      notification.error({
        message: response.message
      })
    }
  }

  rejectApplication = async (recordId) => {
    const rejectReason = prompt('Reason For Rejection');
    if (rejectReason) {
      const response = await Request.rejectApplication({ recordId, rejectReason });
      if (response.success) {
        notification.success({
          message: 'Application rejected successfully',
        })
        this.getNewFiles();
      } else {
        notification.warning({
          message: 'Something wrong, Please try after sometime',
        })
      }
    }
  }

  changeUpdateRequestStatus = async (recordId, status) => {
    const response = await Request.changeUpdateRequestStatus({ recordId, status });
    if (response.success) {
      notification.success({
        message: response.message
      })
      this.getPaymentUpdationRequests();
    } else {
      notification.error({
        message: response.message,
      })
    }
  }

  changeBranchInvoiceStatus = async (invoiceNumber, value) => {
    let rejectionReason = null
    if (value === "Rollback") {
      rejectionReason = prompt('Reason For Rollback');
      if (!rejectionReason) {
        notification.error({ message: 'Please Enter Rollback Reason' });
        return;
      }
    }
    this.setState(prev => ({
      branchInvoiceLoading: {
        ...prev.branchInvoiceLoading,
        [invoiceNumber]: true
      }
    }));
    const response = await Request.changeBranchInvoiceStatus({ invoiceNumber, value, rejectionReason });
    this.setState(prev => ({
      branchInvoiceLoading: {
        ...prev.branchInvoiceLoading,
        [invoiceNumber]: false
      }
    }));
    if (response.success) {
      notification.success({
        message: response.message
      })
    } else {
      notification.error({
        message: response.message
      })
    }
    this.getApBranchInvoicesData();
  }


  acceptAnnoucement = async (id) => {
    const response = await Request.updateAnnoucement({ _id: id });
    if (response.success) {
      notification.success({
        message: response.message
      })
    }
    this.getUnreadAnnoucements();
  }

  closeReviewDrawer = () => {
    this.setState({ inquiryDetail: {}, showReviewDrawer: false }, () => {
      this.getNewFiles();
    })
  }

  parseMongoDate = (date) => {
    if (!date) return null;

    if (
      typeof date === 'object' &&
      date.$date &&
      date.$date.$numberLong
    ) {
      return moment(Number(date.$date.$numberLong));
    }

    if (typeof date === 'number') {
      return moment(date);
    }

    if (typeof date === 'string') {
      return moment(date);
    }

    return null;
  }



  render() {
    const { collapsed, isMobile, logo } = this.props;
    let { totalNewFiles, newFilesData, invoiceObj, totalNewMoveArchiveRequest, newMoveArchiveRequestsData, openUpdatePaymentDrawer, showBranchInvoiceStatusDrawer, openMoveToArchiveDeskDrawer, showPaymentFollowupDrawer, totalPaymentFollowUps, totalPaymentFollowUpsData, totalNewIncentiveFiles, newIncentivesFilesData,
      showReviewDrawer, inquiryDetail
    } = this.state;
    let { ext, linkUrl, branchInvoice, dueInvoicesList, openInvoiceApprovalRequestDrawer, showPaidBranchInvoiceDrawer } = this.state;

    // const moveArchiveColumns = [
    //   {
    //     title: 'Sr. No.',
    //     key: 'serialNumber',
    //     width: 60,
    //     render: (text, record, index) => (
    //       <span>{index + 1}</span>
    //     )
    //   },
    //   {
    //     title: "Action",
    //     key: "operation",
    //     width: 110,
    //     render: (text, record) => (
    //       <React.Fragment>
    //         <Tooltip title="Click To Approve The Request">
    //           &nbsp;&nbsp;&nbsp;<Button
    //             loading={false}
    //             className={styles.btn}
    //             onClick={() => { this.approveMoveArchiveRequest(record._id) }}
    //             shape="circle"
    //             icon="check"
    //             size="medium"
    //           />
    //         </Tooltip>

    //         <Tooltip title="Click To Reject The Request">
    //           &nbsp;<Button
    //             loading={false}
    //             className={styles.btn}
    //             onClick={() => { this.rejectMoveArchiveRequest(record._id) }}
    //             shape="circle"
    //             icon="close"
    //             size="medium"
    //           />
    //         </Tooltip>
    //       </React.Fragment>
    //     ),
    //   },
    //   {
    //     title: 'VID',
    //     key: 'id',
    //     width: 60
    //   },
    //   {
    //     title: 'Student Name',
    //     key: 'studentName',
    //     width: 160,
    //     render: (text, record) => (
    //       <a href={`/desk/getClaim?id=${record._id}`} target="_blank">{record.studentName}</a>
    //     )
    //   },
    //   {
    //     title: 'DOB',
    //     key: 'dateOfBirth',
    //     width: 100,
    //     render: (text, record) => (
    //       <div>{moment(record.dateOfBirth).format(dateFormat)}</div>
    //     )
    //   },
    //   {
    //     title: 'Desk',
    //     key: 'atLevel',
    //   },
    //   {
    //     title: 'Passport Number',
    //     key: 'visaDesk.passportNo',
    //   },
    //   {
    //     title: 'College',
    //     key: 'visaDesk.selectedCourse',
    //     render: (text, record) => (
    //       <div>{record && record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.universityInstitutionName ? record.visaDesk.selectedCourse.universityInstitutionName : "NA"}</div>
    //     )
    //   },
    //   {
    //     title: 'Invoice Details',
    //     key: 'nextInvoiceGenerationDates',
    //     render: (text, record) => {
    //       console.log(record);
    //       return (
    //         <div>
    //           {record.nextInvoiceGenerationDates.map((invoice, index) => (
    //             invoice.generatedInvoices ? (
    //               <div
    //                 key={index}
    //                 style={{ border: '1px solid black', marginBottom: 5, padding: 5 }}
    //               >
    //                 <p>
    //                   <strong>Invoice Number:-</strong>{" "}
    //                   {invoice.generatedInvoices && invoice.generatedInvoices.invoiceNumber ? (
    //                     <a
    //                       href={`/finance-desk?invSTId=${invoice._id}`}
    //                       target="_blank"
    //                       rel="noopener noreferrer"
    //                       style={{ color: '#1890ff', cursor: 'pointer' }}
    //                     >
    //                       {invoice.generatedInvoices.invoiceNumber}
    //                     </a>
    //                   ) : (
    //                     "NA"
    //                   )}
    //                 </p>

    //                 <p>
    //                   <strong>Generated Date:-</strong>{" "}
    //                   {invoice.generatedInvoices &&
    //                     invoice.generatedInvoices.invoiceGeneratedDate
    //                     ? moment(invoice.generatedInvoices.invoiceGeneratedDate).format(dateFormat)
    //                     : "NA"}
    //                 </p>

    //                 <p>
    //                   <strong>Invoice Status:-</strong>{" "}
    //                   {invoice.generatedInvoices && invoice.generatedInvoices.invoiceStatus
    //                     ? invoice.generatedInvoices.invoiceStatus
    //                     : "NA"}
    //                 </p>
    //                 <p>
    //                   <strong>Receipt:-</strong>
    //                   {invoice.generatedInvoices && invoice.generatedInvoices.paymentReceipt
    //                     ? <a
    //                       href={`${MEDIA_URL}${invoice.generatedInvoices.paymentReceipt[0].url}`}
    //                       target="_blank"
    //                       rel="noopener noreferrer"
    //                       style={{ color: '#1890ff', cursor: 'pointer' }}
    //                     >View</a>
    //                     : "NA"}
    //                 </p>
    //               </div>

    //             ) :
    //               <div
    //                 key={index}
    //                 style={{ border: '1px solid black', marginBottom: 5, padding: 5 }}
    //               >
    //                 <p>
    //                   <strong>Invoice Number:-</strong>{" "}
    //                   {(invoice.uploaded &&
    //                     Array.isArray(invoice.cpUploadInvoice) &&
    //                     invoice.cpUploadInvoice.length > 0 &&
    //                     (invoice.cpInvoiceNumber || invoice.invoiceGeneratedNumber)) ? (
    //                     <a
    //                       href={`${MEDIA_URL}${invoice.cpUploadInvoice[0].url}`}
    //                       target="_blank"
    //                       rel="noopener noreferrer"
    //                       style={{ color: '#1890ff', cursor: 'pointer' }}
    //                     >
    //                       {invoice.cpInvoiceNumber || invoice.invoiceGeneratedNumber}
    //                     </a>
    //                   ) : (
    //                     invoice.cpInvoiceNumber ||
    //                     invoice.invoiceGeneratedNumber ||
    //                     "NA"
    //                   )}
    //                 </p>

    //                 <p>
    //                   <strong>Generated Date:-</strong>{" "}
    //                   {invoice.invoiceGeneratedDate
    //                     ? moment(invoice.invoiceGeneratedDate).format(dateFormat)
    //                     : invoice.generationDate
    //                       ? moment(invoice.generationDate).format(dateFormat)
    //                       : invoice.invoiceAddedDate
    //                         ? moment(invoice.invoiceAddedDate).format(dateFormat)
    //                         : "NA"}
    //                 </p>

    //                 <p>
    //                   <strong>Invoice Status:-</strong>{" "}
    //                   {invoice.invoiceStatus || "NA"}
    //                 </p>
    //                 <p>
    //                   <strong>Receipt:-</strong>
    //                   {Array.isArray(invoice.cpReceiptUpload) && invoice.cpReceiptUpload.length > 0 ?
    //                     <a
    //                       href={`${MEDIA_URL}${invoice.cpReceiptUpload[0].url}`}
    //                       target="_blank"
    //                       rel="noopener noreferrer"
    //                       style={{ color: '#1890ff', cursor: 'pointer' }}
    //                     >View</a>
    //                     : "NA"}
    //                 </p>
    //               </div>
    //           ))
    //           }
    //         </div >
    //       );
    //     }
    //   },
    //   {
    //     title: 'Updated By',
    //     width: 110,
    //     key: 'updatedByUser',
    //     dataIndex: 'updatedByUser',
    //     searchTextName: 'Updated By',
    //     render: (text, record) => {
    //       return (
    //         <div>
    //           <div >{text ? text.name : ''} </div>
    //           <small>{text ? moment(text.time).local().format("lll") : ""}</small>
    //         </div>
    //       )
    //     }
    //   },
    // ]

    const moveArchiveColumns = [
      {
        title: 'Sr. No.',
        key: 'serialNumber',
        width: 60,
        align: 'center',
        render: (text, record, index) => (
          <span style={{ fontWeight: 600, color: '#8c8c8c' }}>{index + 1}</span>
        )
      },
      {
        title: "Action",
        key: "operation",
        width: 110,
        align: 'center',
        render: (text, record) => (
          <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', alignItems: 'center' }}>
            <Tooltip title="Click To Approve The Request">
              <Button
                loading={false}
                className={styles.btn}
                onClick={() => { this.approveMoveArchiveRequest(record._id) }}
                shape="circle"
                icon="check"
                size="small"
                style={{ background: '#52c41a', borderColor: '#52c41a', color: '#fff' }}
              />
            </Tooltip>

            <Tooltip title="Click To Reject The Request">
              <Button
                loading={false}
                className={styles.btn}
                onClick={() => { this.rejectMoveArchiveRequest(record._id) }}
                shape="circle"
                icon="close"
                size="small"
                type="danger"
              />
            </Tooltip>
          </div>
        ),
      },
      {
        title: 'Student Details',
        key: 'studentDetailsCombined',
        width: 280,
        render: (text, record) => {
          var studentId = record && record._id ? record._id : '';
          var studentVid = record && record.id ? record.id : '-';
          var passportNo = record && record.visaDesk && record.visaDesk.passportNo ? record.visaDesk.passportNo : (record.passportNumber || "-");
          var currentDesk = record && record.atLevel ? record.atLevel : '-';

          return (
            <div style={{
              padding: '12px',
              background: '#fafafa',
              borderRadius: '8px',
              border: '1px solid #e8e8e8',
              lineHeight: '22px',
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              {/* Name Block with Redirection Link */}
              <div style={{ fontSize: '14px', marginBottom: '2px' }}>
                <Icon type="user" style={{ marginRight: 6, color: '#1677ff' }} />
                <a
                  href={`/desk/getClaim?id=${studentId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ fontWeight: 700, color: '#1677ff', textDecoration: 'none', borderBottom: '1px dashed #1677ff' }}
                >
                  {record.studentName}
                </a>
              </div>

              {/* VID & Passport Meta Row */}
              <div style={{ fontSize: '11px', color: '#8c8c8c' }}>
                <b>VID:</b> {studentVid} | <b>Passport:</b> <span style={{ fontVariantNumeric: 'tabular-nums' }}>{passportNo}</span>
              </div>

              {/* DOB Identifier */}
              <div style={{ color: '#595959', fontSize: '11px' }}>
                <Icon type="calendar" style={{ marginRight: 6, color: '#bfbfbf' }} />
                <b>DOB:</b> {record.dateOfBirth ? moment(record.dateOfBirth).format(dateFormat) : '-'}
              </div>

              {/* Desk Level Status Tag */}
              <div style={{ marginTop: '4px' }}>
                <span style={{
                  background: '#f5f5f5',
                  padding: '2px 8px',
                  borderRadius: '4px',
                  fontSize: '10px',
                  border: '1px solid #d9d9d9',
                  color: '#595959',
                  fontWeight: 600,
                  textTransform: 'uppercase'
                }}>
                  {currentDesk}
                </span>
              </div>
            </div>
          );
        }
      },
      {
        title: 'College',
        key: 'visaDesk.selectedCourse',
        width: 200,
        render: (text, record) => (
          <div style={{ lineHeight: '18px' }}>
            <div style={{ fontWeight: 600, color: '#262626' }}>
              <Icon type="bank" style={{ marginRight: 5, color: '#bfbfbf' }} />
              {record && record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.universityInstitutionName ? record.visaDesk.selectedCourse.universityInstitutionName : "NA"}
            </div>
            {record && record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.courseName && (
              <div style={{ fontSize: '11px', color: '#8c8c8c', fontStyle: 'italic' }}>{record.visaDesk.selectedCourse.courseName}</div>
            )}
          </div>
        )
      },
      {
        title: 'Invoice Details',
        key: 'nextInvoiceGenerationDates',
        width: 290,
        render: (text, record) => {
          console.log(record);
          return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {record.nextInvoiceGenerationDates.map((invoice, index) => {

                var hasGen = invoice && invoice.generatedInvoices;
                var targetSource = hasGen ? invoice.generatedInvoices : invoice;

                var commGrandTotal = targetSource && targetSource.commissionGrandTotal ? Number(targetSource.commissionGrandTotal) : targetSource && targetSource.commReceived ? Number(targetSource.commReceived) : 0;

                var innerInvoices = targetSource && targetSource.invoices ? targetSource.invoices : [];
                var firstInnerInv = innerInvoices.length > 0 ? innerInvoices[0] : null;

                var rateConversion = firstInnerInv && firstInnerInv.conversionRate ? firstInnerInv.conversionRate : (invoice.conversionRate || '-');
                var currencyType = firstInnerInv && firstInnerInv.currency ? firstInnerInv.currency : (invoice.currency || 'AUD');
                // var grossReceived = firstInnerInv && firstInnerInv.grossPaymentReceived ? Number(firstInnerInv.grossPaymentReceived) : (Number(invoice.grossPaymentReceived) || 0);
                var grossReceived = firstInnerInv && firstInnerInv.grossPaymentReceived ? Number(firstInnerInv.grossPaymentReceived) : Number(invoice.totalAfterConversion || 0);
                var commConverted = firstInnerInv && firstInnerInv.commissionTotalConverted ? Number(firstInnerInv.commissionTotalConverted) : (Number(invoice.totalAfterConversion) || 0);
                var adjustmentAmt = firstInnerInv && firstInnerInv.adjustmentAmount ? Number(firstInnerInv.adjustmentAmount) : (Number(invoice.adjustmentAmount) || 0);

                var taxesList = targetSource && targetSource.cpTaxDetails ? targetSource.cpTaxDetails : [];
                var totalTaxSum = taxesList.reduce((sum, t) => sum + (Number(t.totalCpTax) || 0), 0);

                var feeReceiptArr = invoice && invoice.feeReceipt && invoice.feeReceipt.files ? invoice.feeReceipt.files : [];
                var feeReceiptUrl = feeReceiptArr.length > 0 && feeReceiptArr[0].url ? feeReceiptArr[0].url : null;

                var swiftCopyArr = invoice && invoice.swiftCopy && invoice.swiftCopy.files ? invoice.swiftCopy.files : [];
                var swiftCopyUrl = swiftCopyArr.length > 0 && swiftCopyArr[0].url ? swiftCopyArr[0].url : null;

                var currentStatus = (hasGen ? invoice.generatedInvoices.invoiceStatus : invoice.invoiceStatus) || 'PENDING';

                var getStatusColors = function (currentStatus) {
                  var s = currentStatus ? currentStatus.toUpperCase() : 'PENDING';
                  var config = {
                    'PENDING': { color: '#d48806', bg: '#fffbe6', border: '#ffe58f' },
                    'CLEARED': { color: '#237804', bg: '#f6ffed', border: '#95de64' },
                    'APPROVED': { color: '#389e0d', bg: '#f6ffed', border: '#b7eb8f' },
                    'GENERATED': { color: '#096dd9', bg: '#e6f7ff', border: '#91d5ff' },
                    'PAID BY UNI': { color: '#531dab', bg: '#f9f0ff', border: '#d3adf7' },
                    'SUBMITTED TO UNI': { color: '#096dd9', bg: '#e6f7ff', border: '#91d5ff' }
                  };
                  return config[s] || { color: '#595959', bg: '#f5f5f5', border: '#d9d9d9' };
                };

                var statusStyles = getStatusColors(currentStatus);

                return (
                  <div
                    key={index}
                    style={{
                      padding: '12px',
                      background: '#fff',
                      borderRadius: '10px',
                      border: '1px solid #e8e8e8',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.03)',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '6px',
                      lineHeight: '20px'
                    }}
                  >
                    {/* Header Row: Inv Number & Status Badge */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontWeight: 700, fontSize: '13px' }}>
                        {hasGen ? (
                          invoice.generatedInvoices.invoiceNumber ? (
                            <a
                              href={`/finance-desk?invSTId=${invoice._id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: '#1677ff', textDecoration: 'none', borderBottom: '1px dashed #1677ff' }}
                            >
                              Inv#: {invoice.generatedInvoices.invoiceNumber}
                            </a>
                          ) : "Inv#: NA"
                        ) : (
                          (invoice.uploaded && Array.isArray(invoice.cpUploadInvoice) && invoice.cpUploadInvoice.length > 0 && (invoice.cpInvoiceNumber || invoice.invoiceGeneratedNumber)) ? (
                            <a
                              href={`${MEDIA_URL}${invoice.cpUploadInvoice[0].url}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: '#1677ff', textDecoration: 'none', borderBottom: '1px dashed #1677ff' }}
                            >
                              Inv#: {invoice.cpInvoiceNumber || invoice.invoiceGeneratedNumber}
                            </a>
                          ) : "Inv#: " + (invoice.cpInvoiceNumber || invoice.invoiceGeneratedNumber || "NA")
                        )}
                      </span>

                      <span style={{
                        fontSize: '10px',
                        fontWeight: 700,
                        color: statusStyles.color,
                        background: statusStyles.bg,
                        border: '1px solid ' + statusStyles.border,
                        padding: '1px 8px',
                        borderRadius: '12px',
                        textTransform: 'uppercase'
                      }}>
                        {currentStatus}
                      </span>
                    </div>

                    {/* Date Row */}
                    <div style={{ fontSize: '11px', color: '#8c8c8c' }}>
                      <Icon type="calendar" style={{ marginRight: 4 }} />
                      <strong>Gen Date:</strong> {hasGen ? (
                        invoice.generatedInvoices.invoiceGeneratedDate ? moment(invoice.generatedInvoices.invoiceGeneratedDate).format('DD.MM.YYYY') : "NA"
                      ) : (
                        invoice.invoiceGeneratedDate ? moment(invoice.invoiceGeneratedDate).format('DD.MM.YYYY') : (invoice.generationDate ? moment(invoice.generationDate).format('DD.MM.YYYY') : (invoice.invoiceAddedDate ? moment(invoice.invoiceAddedDate).format('DD.MM.YYYY') : "NA"))
                      )}
                    </div>

                    {/* Premium Inner Financial Metrics Box */}
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '2px',
                      background: '#fafafa',
                      padding: '8px',
                      borderRadius: '6px',
                      border: '1px dashed #d9d9d9',
                      fontSize: '11px',
                      color: '#434343'
                    }}>
                      <div><b>Invoice Comm:</b> {currencyType} {commGrandTotal.toFixed(2)}</div>
                      <div><b>Comm Converted:</b> INR {commConverted.toFixed(2)}</div>
                      {adjustmentAmt !== 0 && (
                        <div style={{ color: adjustmentAmt > 0 ? '#52c41a' : '#f5222d', fontWeight: 600 }}>
                          <b>Adjustment:</b> {adjustmentAmt > 0 ? '+' : ''}{adjustmentAmt.toFixed(2)}
                        </div>
                      )}
                      <div style={{ color: '#1677ff', fontWeight: 600, borderTop: '1px dashed #f0f0f0', marginTop: '4px', paddingTop: '2px' }}>
                        <b>Gross Total:</b> INR {grossReceived.toFixed(2)}
                      </div>
                      {totalTaxSum > 0 && <div style={{ color: '#f5222d' }}><b>Tax (GST):</b> INR {totalTaxSum.toFixed(2)}</div>}
                      <div style={{ color: '#8c8c8c', fontSize: '10px', marginTop: '2px' }}>
                        <Icon type="swap" style={{ marginRight: 4 }} /> Ex Rate: 1 {currencyType} = {rateConversion} INR
                      </div>
                    </div>

                    {/* Actionable Documents Links Section */}
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', fontSize: '11px', marginTop: '2px' }}>
                      {hasGen ? (
                        invoice.generatedInvoices.paymentReceipt && (
                          <a href={`${MEDIA_URL}${invoice.generatedInvoices.paymentReceipt[0].url}`} target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff', fontWeight: 500 }}>
                            <Icon type="file-done" style={{ marginRight: 3 }} /> Receipt
                          </a>
                        )
                      ) : (
                        Array.isArray(invoice.cpReceiptUpload) && invoice.cpReceiptUpload.length > 0 && (
                          <a href={`${MEDIA_URL}${invoice.cpReceiptUpload[0].url}`} target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff', fontWeight: 500 }}>
                            <Icon type="file-done" style={{ marginRight: 3 }} /> Receipt
                          </a>
                        )
                      )}

                      {feeReceiptUrl && (
                        <a href={`${MEDIA_URL}${feeReceiptUrl}`} target="_blank" rel="noopener noreferrer" style={{ color: '#2f54eb', fontWeight: 500 }}>
                          <Icon type="file-text" style={{ marginRight: 3 }} /> Fee Receipt
                        </a>
                      )}

                      {swiftCopyUrl && (
                        <a href={`${MEDIA_URL}${swiftCopyUrl}`} target="_blank" rel="noopener noreferrer" style={{ color: '#722ed1', fontWeight: 500 }}>
                          <Icon type="swap" style={{ marginRight: 3 }} /> Swift Copy
                        </a>
                      )}
                    </div>
                  </div>
                );
              })
              }
            </div >
          );
        }
      },
    ];

    const annoucementColumns = [
      {
        title: 'Sr. No.',
        key: 'serialNumber',
        width: 60,
        render: (text, record, index) => (
          <span>{index + 1}</span>
        )
      },
      {
        title: 'Action',
        key: 'operation',
        width: 120,
        render: (text, record) => (
          <React.Fragment>
            <Tooltip title="Click To Acknowledge">
              &nbsp;&nbsp;&nbsp;<Button
                loading={false}
                className={styles.btn}
                onClick={() => { this.acceptAnnoucement(record._id) }}
                shape="circle"
                icon="check"
              />
            </Tooltip>
          </React.Fragment>
        )
      },
      {
        title: 'Description',
        key: 'annoucementText'
      },
      {
        title: 'Added By',
        key: 'createdByUser.name',
        width: 120
      }

    ];

    const updatePaymentColumns = [
      {
        title: 'Sr. No.',
        key: 'serialNumber',
        width: 60,
        render: (text, record, index) => (
          <span>{index + 1}</span>
        )
      },
      {
        title: 'Action',
        key: 'operation',
        width: 120,
        render: (text, record) => (
          <React.Fragment>
            <Tooltip title="Click To Approve The Request">
              &nbsp;&nbsp;&nbsp;<Button
                loading={false}
                className={styles.btn}
                onClick={() => { this.changeUpdateRequestStatus(record._id, "Approved") }}
                shape="circle"
                icon="check"
              />
            </Tooltip>

            <Tooltip title="Click To Reject The Request">
              &nbsp;<Button
                loading={false}
                className={styles.btn}
                onClick={() => { this.changeUpdateRequestStatus(record._id, "Rejected") }}
                shape="circle"
                icon="close"
              />
            </Tooltip>
          </React.Fragment>
        )
      },
      {
        title: 'Receipt Number',
        key: 'receiptNumber',
        width: 70,
        render: (text, record) => (
          <span>{record['payment_details']['receiptNumber']}</span>
        )
      },
      {
        title: 'Name',
        key: 'studentName',
        width: 120,
        render: (text, record) => (
          <span>{record['payment_details']['studentName']}</span>
        )
      },
      {
        title: 'Field Name',
        key: 'fieldName',
        width: 120,
        render: (text, record) => {
          const fields = {
            "dob": "Date Of Birth",
            "paymentDate": "Payment Date",
            "studentName": "Student Name",
            "totalAmount": "Amount",
          }
          return (
            <span>{fields[record.fieldName]}</span>
          )
        }
      },
      {
        title: 'Old Value',
        key: 'oldValue',
        width: 80,
        render: (text, record) => {
          if (record.fieldName !== "paymentDate") {
            return (
              <span>{record['payment_details'][record.fieldName]}</span>
            )
          } else {
            return (
              <span>{moment(record['payment_details']['createdByUser.time']).format(dateFormat)}</span>
            )
          }

        }
      },
      {
        title: 'New Value',
        key: 'newValue',
        width: 120,
        render: (text, record) => {
          if (record.fieldName !== "paymentDate" && record.fieldName !== "dob") {
            return (
              <span>{record.newValue}</span>
            )
          } else {
            return (
              <span>{moment(record.newValue).format(dateFormat)}</span>
            )
          }
        }
      },
      {
        title: 'Total Amount',
        key: 'amount',
        width: 70,
        render: (text, record) => (
          <span>{record['payment_details']['totalAmount']}</span>
        )
      },
      {
        title: 'Update Reason',
        key: 'reasonForUpdation',
        width: 120,
      },
      {
        title: "Created By",
        width: 100,
        key: "createdByUser",
        render: (text, record) => {
          return (
            <div>
              <div>{text ? text.name : ""}</div>
              <small>{text ? moment(text.time).format("lll") : ""}</small>
            </div>
          );
        },
      },
    ]
    const branchInvoiceColumns = [
      {
        title: 'Sr. No.',
        key: 'serialNumber',
        width: 60,
        render: (text, record, index) => (
          <span>{index + 1}</span>
        )
      },
      {
        title: 'Action',
        key: 'operation',
        width: 120,
        render: (text, record) => (
          <React.Fragment>
            <Tooltip title="Click To Approve The Request">
              &nbsp;&nbsp;&nbsp;<Button
                loading={this.state.branchInvoiceLoading[record.invoiceNumber]}
                className={styles.btn}
                onClick={() => { this.changeBranchInvoiceStatus(record.invoiceNumber, "Approved") }}
                shape="circle"
                icon="check"
              />
            </Tooltip>

            <Tooltip title="Click To Reject The Request">
              &nbsp;<Button
                loading={this.state.branchInvoiceLoading[record.invoiceNumber]}
                className={styles.btn}
                onClick={() => { this.changeBranchInvoiceStatus(record.invoiceNumber, "Rollback") }}
                shape="circle"
                icon="close"
              />
            </Tooltip>
          </React.Fragment>
        )
      },
      {
        title: 'Invoice Number',
        key: 'invoiceNumber'
      },
      {
        title: 'Branch/Ap Name',
        key: 'branchDetails.branchName',
      },
      {
        title: 'View Invoice',
        key: 'branchInvoice',
        render: (text, record) => (
          <Button icon="eye" type="primary" onClick={() => this.viewBranchInvoice(record.invoiceUrl)} />
        )
      },
      {
        title: 'View Students',
        key: 'students',
        render: (text, record) => (
          <Button
            icon="eye"
            type="primary"
            onClick={() => window.open(`/finance-branch-claim-desk?inv=${record.invoiceNumber}`, "_blank")}
          />
        )
      }

    ]

    const paymentFollowupsColumns = [
      {
        title: "Sr. No.",
        key: 'serialNumber',
        width: 60,
        render: (text, record, index) => (
          <span>{index + 1}</span>
        )
      },
      {
        title: 'Action',
        key: 'operation',
        width: 60,
        render: (text, record) => (
          <Tooltip title="FollowUps">
            <Button
              className={styles.btn}
              size={"small"}
              shape="circle"
              onClick={() => this.openFollowUps(record)}
              icon="calendar"
            />
          </Tooltip>
        )
      },
      {
        title: 'Invoice Number',
        key: 'invoiceNumber',
        width: 80,
      },
      {
        title: 'Invoice Type',
        key: 'invoiceType',
        width: 80
      },
      {
        title: 'Invoice To Name',
        key: 'invoiceToName',
        width: 120,
      },
      {
        title: 'Invoice To Email',
        key: 'invoiceToEmail',
        width: 120,
      },
      {
        title: 'Generated Date',
        key: 'invoiceGeneratedDate',
        width: 80,
        render: (text, record) => (
          record.invoiceGeneratedDate ? moment(record.invoiceGeneratedDate).format(dateFormat) : "N/A"
        )
      },
      {
        title: 'Invoice Status',
        key: 'invoiceStatus',
        width: 80
      },

    ]


    // const dueInvoicesColumns = [
    //   {
    //     title: 'Sr. No.',
    //     key: 'serialNumber',
    //     width: 60,
    //     render: (text, record, index) => (
    //       <span>{index + 1}</span>
    //     )
    //   },
    //   {
    //     title: 'VID',
    //     key: 'id',
    //     render: (text, record) => {
    //       const redirectPath = link[record.atLevel] || "#";
    //       return (
    //         <div className="student-info-wrapper">
    //           <div style={{ fontWeight: 700, color: "#1a3353", fontSize: '15px' }}>
    //             <a
    //               href={redirectPath + '?id=' + record._id}
    //               target="_blank"
    //               rel="noopener noreferrer"
    //             >
    //               {record.id}
    //             </a>
    //           </div>
    //         </div>
    //       );
    //     }
    //   },
    //   {
    //     title: 'Student Name',
    //     key: 'studentName',
    //   },
    //   {
    //     title: 'D.O.B',
    //     key: 'dateOfBirth',
    //     render: (text, record) => (
    //       <span>{record.dateOfBirth ? moment(record.dateOfBirth).format(dateFormat) : "NA"}</span>
    //     )
    //   },
    //   {
    //     title: 'Passport No',
    //     key: 'visaDesk.passportNo',
    //   },
    //   {
    //     title: 'College',
    //     key: 'visaDesk.selectedCourse.universityInstitutionName'
    //   },
    //   {
    //     title: 'Invoice Due Date',
    //     key: 'invoiceDueDate',
    //     render: function (text, record) {
    //       if (
    //         !record ||
    //         !record.nextInvoiceGenerationDates ||
    //         !record.nextInvoiceGenerationDates.length
    //       ) {
    //         return 'NA';
    //       }

    //       const todayEnd = moment().endOf('day');
    //       let matchedInvoice = null;

    //       for (let i = 0; i < record.nextInvoiceGenerationDates.length; i++) {
    //         const item = record.nextInvoiceGenerationDates[i];

    //         if (item.withdrawRequest === true) {
    //           continue;
    //         }
    //         const genDate = parseMongoDate(item.generationDate)
    //         // const genDate = this.parseMongoDate(item.generationDate);
    //         if (!genDate || !genDate.isValid()) {
    //           continue;
    //         }

    //         // ✅ CASE 1: Not generated & due
    //         if (
    //           item.invoiceGenerated === false &&
    //           genDate.isSameOrBefore(todayEnd)
    //         ) {
    //           matchedInvoice = item;
    //           break;
    //         }

    //         // ✅ CASE 2: Generated & PI-TP / GPI-TP
    //         if (
    //           item.invoiceGenerated === true &&
    //           item.invoiceGeneratedNumber &&
    //           /^(PI-TP|GPI-TP)/.test(item.invoiceGeneratedNumber) &&
    //           genDate.isSameOrBefore(todayEnd)
    //         ) {
    //           matchedInvoice = item;
    //           break;
    //         }
    //       }

    //       if (matchedInvoice && matchedInvoice.generationDate) {
    //         const dateObj = parseMongoDate(matchedInvoice.generationDate);
    //         // const dateObj = this.parseMongoDate(matchedInvoice.generationDate);
    //         return dateObj ? dateObj.format(dateFormat) : 'NA';
    //       }

    //       return 'NA';
    //     }
    //   }


    // ]

    const dueInvoicesColumns = [
      {
        title: 'Sr. No.',
        key: 'serialNumber',
        width: 60,
        render: (text, record, index) => index + 1
      },
      {
        title: 'VID',
        key: 'id',
        render: (text, record) => {
          const redirectPath = link[record.atLevel] || "#";
          return (
            <a
              href={redirectPath + '?id=' + record._id}
              target="_blank"
              rel="noopener noreferrer"
            >
              {record.id}
            </a>
          );
        }
      },
      {
        title: 'Student Name',
        key: 'studentName',
        render: (text, record) => (
          <a
            href={`/inquiry/studentProfileDetails?id=${record._id}`}
            target="_blank"
            rel="noopener noreferrer"
          >{text}</a>
        )
      },
      {
        title: 'D.O.B',
        key: 'dateOfBirth',
        render: (_, record) =>
          record.dateOfBirth
            ? moment(record.dateOfBirth).format(dateFormat)
            : 'NA'
      },
      {
        title: 'Desk',
        key: 'atLevel',
        render: (text, record) => (
          <span>{record && record.atLevel === "Front Desk" ? "Counselling Desk" : record.atLevel}</span>
        )
      },
      {
        title: 'Passport No',
        key: 'visaDesk.passportNo'
      },
      {
        title: 'Branch',
        key: 'branch_details.branchName'
      },
      {
        title: 'Sub Agent',
        key: 'associate_partner_details.branchName',
        render: (text, record) => {
          var subAgent = record && record.associate_partner_details;

          return (
            <span>
              {subAgent && subAgent.branchName ? subAgent.branchName : 'N/A'}
            </span>
          );
        }
      },
      {
        title: 'Channel Partner',
        key: 'visDesk.selectedCourse.channelPartnerName',
        render: (text, record) => {
          let channelPartnerName = record && record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.channelPartnerName ? record.visaDesk.selectedCourse.channelPartnerName : "N/A";
          return (
            <span>{channelPartnerName}</span>
          )
        }
      },
      {
        title: 'College',
        key: 'visaDesk.selectedCourse.universityInstitutionName'
      },
      {
        title: 'Follow-Up Note',
        key: 'followUp',
        render: (text, record) => (
          <LatestFollowup info={record && record.followUp} />
        )
      },
      {
        title: 'Invoice Due Date',
        key: 'invoiceDueDate',

        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <DatePicker.RangePicker
              value={selectedKeys[0]}
              onChange={(dates) =>
                setSelectedKeys(dates ? [dates] : [])
              }
              format="DD-MM-YYYY"
              style={{ marginBottom: 8, display: 'block' }}
            />

            <Button
              type="primary"
              size="small"
              onClick={() => confirm()}
              style={{ width: '100%', marginBottom: 4 }}
            >
              Apply
            </Button>

            <Button
              size="small"
              onClick={() => {
                clearFilters();
                confirm();
              }}
              style={{ width: '100%' }}
            >
              Reset
            </Button>
          </div>
        ),

        onFilter: (value, record) => {
          const dueDate = this.getInvoiceDueMoment(record);
          if (!dueDate || !value) return false;

          const [start, end] = value;

          return dueDate.isBetween(
            start.startOf('day'),
            end.endOf('day'),
            null,
            '[]'
          );
        },

        render: (_, record) => {
          const dueDate = this.getInvoiceDueMoment(record);
          return dueDate ? dueDate.format(dateFormat) : 'NA';
        }
      }
    ];
    const incentiveInvoiceColumns = [
      {
        title: 'Sr. No.',
        key: 'serialNumber',
        width: 60,
        render: (text, record, index) => (
          <span>{index + 1}</span>
        )
      },
      {
        title: 'Action',
        key: 'operation',
        width: 140,
        render: (text, record) => (
          <Tooltip title="Accept Incentive Invoice" >
            <Button icon="check" shape="circle" onClick={() => this.acceptIncentiveInvoice(record._id)}></Button>
          </Tooltip>
        )
      },
      {
        title: 'Invoice Number',
        key: 'invoiceNumber'
      },
      {
        title: 'Name',
        key: 'userId.name'
      },
      {
        title: 'Total Amount',
        key: 'totalAmount'
      },
      {
        title: 'Status',
        key: 'status'
      }
    ]

    const columnOverallReport = [
      {
        title: "Action",
        key: "operation",
        width: 140,
        render: (text, record) => (
          <React.Fragment>
            {
              currentUser && currentUser.isClaim && record && record.followUp && record.followUp.assignByUserId !== currentUser._id ? null : (
                <>
                  <Tooltip title="Click To Approve The Student">
                    &nbsp;&nbsp;&nbsp;<Button
                      loading={false}
                      className={styles.btn}
                      onClick={() => { this.approveApplication(record._id) }}
                      shape="circle"
                      icon="check"
                    />
                  </Tooltip>

                  <Tooltip title="Click To Rollback The Student">
                    &nbsp;<Button
                      loading={false}
                      className={styles.btn}
                      onClick={() => { this.rejectApplication(record._id) }}
                      shape="circle"
                      icon="close"
                    />
                  </Tooltip>
                </>
              )
            }
            {
              currentUser && currentUser.isClaim && record && record.followUp && record.followUp.assignByUserId !== currentUser._id ? (
                <Tooltip title="Show Followups">
                  &nbsp;<Button
                    loading={false}
                    className={styles.btn}
                    onClick={() => this.openStudenFollowUps(record)}
                    shape="circle"
                    icon="calendar"
                  />
                </Tooltip>
              ) : null
            }
            {
              currentUser && currentUser.isClaim && (
                <>
                  <Tooltip title="Click To Review Details of Student">
                    &nbsp;<Button
                      loading={false}
                      className={styles.btn}
                      onClick={() => { this.setState({ showReviewDrawer: true, inquiryDetail: record }) }}
                      shape="circle"
                      icon="forward"
                    />
                  </Tooltip>
                </>
              )
            }
          </React.Fragment>
        ),
      },
      {
        title: "ID",
        key: "id",
      },
      {
        title: "Student Name",
        key: "studentName",
        filterRegex: true,
        render: (text, record) => (
          <React.Fragment>
            <div
            >
              {text}
            </div>
          </React.Fragment>
        ),
      },
      {
        title: "DOB ",
        width: 100,
        key: "dateOfBirth",
        render: (val, record) => {
          return (
            <div>
              {record.dateOfBirth
                ? moment(record.dateOfBirth).format("DD-MMM-YYYY")
                : ""}
            </div>
          );
        },
      },
      {
        title: "Desk",
        key: "atLevel",
      },
      {
        title: "Source",
        key: "location",
      },
      {
        title: "Mode",
        key: "mode",
      },
      {
        title: "Counsellor",
        key: "counsellorId",
        render: (text, record) => {
          return (
            <div>{record.counsellorId ? record.counsellorId.name : ""}</div>
          );
        },
      },
      {
        title: "Follow Up",
        key: "followUp.followUpDate",
        width: 200,
        dataIndex: "followUp",
        render: (text, record) => {
          return <LatestFollowup info={text} />;
        },
      },
      {
        title: "Last Updated By",
        width: 150,
        key: "updatedByUser",
        render: (text, record) => {
          return (
            <div>
              <div>{text ? text.name : ""}</div>
              <small>{text ? moment(text.time).format("lll") : ""}</small>
            </div>
          );
        },
      },
    ]

    let popupOpenTime = moment().format('HH');
    return (
      <div className={styles.header}>
        {this.state.showStudentFollowUp ? (
          <ListStudentFollowUp studentObj={studentObj} onClose={this.closeStudentFollowUp} />
        ) : null}
        {
          popupOpenTime >= 16 && popupOpenTime <= 18 ?
            <RightsWrapper myRight={"pendingConsultancyFeesToAccountant.view"}>
              <PendingConsultancyFollowups />
            </RightsWrapper>
            : null
        }
        {
          this.state.showInquiryModal ?
            <AddInquiryModal onClose={() => this.setState({ showInquiryModal: false })} />
            : null
        }
        {
          openInvoiceApprovalRequestDrawer ?
            <InvoiceApprovalDrawer onClose={this.closeInvoiceApprovalRequest} />
            : null
        }
        {
          showPaidBranchInvoiceDrawer ?
            <BranchPaidInvoiceDrawer onClose={this.closePaidBranchInvoiceDrawer} />
            : null
        }
        {
          showReviewDrawer ?
            <InquiryReviewDrawer details={inquiryDetail} onClose={this.closeReviewDrawer} />
            : null
        }

        {
          ext != null && branchInvoice.length > 0 ?
            <PDFFileView linkUrl={linkUrl} ext={ext} onClose={this.closePDFDocument} />
            : null
        }
        {isMobile && (
          <Link to="/" className={styles.logo} key="logo">
            <img src={logo} alt="logo" width="32" />
          </Link>
        )}

        {
          this.state.openWithDrawStudentDrawer ?
            <WithdrawRequestsListDrawer onClose={this.closeWithdrawRequestDrawer} />
            : null
        }

        {
          this.state.openClaimRequestDrawer ?
            <MoveToClaimRequestDrawer onClose={this.closeClaimRequestDrawer} />
            : null
        }
        <span className={styles.trigger} onClick={this.toggle}>
          <Icon type={collapsed ? "menu-unfold" : "menu-fold"} />
        </span>

        <span className={styles.iconspan}>
          {/* <RightsWrapper myRight={"Student.add"}>
            <Tooltip title={"Add Lead"}>
              <span className={styles.deskIcons}>
                <a href={"/inquiry/add"}>
                  <FaPlusCircle />
                </a>
              </span>
            </Tooltip>
          </RightsWrapper> */}
          <RightsWrapper myRight={"Student.add"}>
            <Tooltip title={"Register New Student"}>
              <span
                className={styles.deskIcons}
                onClick={() => this.setState({ showInquiryModal: true })}
              >
                <a><FaPlusCircle className={styles.icon} /></a>
              </span>
            </Tooltip>
          </RightsWrapper>

          <RightsWrapper myRight={"OperationManagerDesk.view"}>
            <Tooltip title={"Operation Manager Desk"}>
              <span className={styles.deskIcons}>
                <a href={"/desk/operation-manager-desk"}>
                  <FaPollH />
                </a>
              </span>
            </Tooltip>
          </RightsWrapper>

          <RightsWrapper myRight={"CounsellingDesk.view"}>
            <Tooltip title={"Counselling Desk"}>
              <span className={styles.deskIcons}>
                <a href={"/desk/all-desk"}>
                  <FaDesktop />
                </a>
              </span>
            </Tooltip>
          </RightsWrapper>

          <RightsWrapper myRight={"RegistrationDesk.view"}>
            <Tooltip title={"Registration Desk"}>
              <span className={styles.deskIcons}>
                <a href={"/desk/allRegistration-desk"}>
                  <FaUserPlus />
                </a>
              </span>
            </Tooltip>
          </RightsWrapper>

          <RightsWrapper myRight={"ApplicationDesk.view"}>
            <Tooltip title={"Application Desk"}>
              <span className={styles.deskIcons}>
                <a href={"/desk/allApplication-desk"}>
                  <FaFileAlt />
                </a>
              </span>
            </Tooltip>
          </RightsWrapper>

          <RightsWrapper myRight={"VisaDesk.view"}>
            <Tooltip title={"Visa Desk"}>
              <span className={styles.deskIcons}>
                <a href={"/desk/allVisa-desk"}>
                  <FaPlaneDeparture />
                </a>
              </span>
            </Tooltip>
          </RightsWrapper>

          <RightsWrapper myRight={"ClaimDesk.view"}>
            <Tooltip title={"Claim Desk"}>
              <span className={styles.deskIcons}>
                <a href={"/desk/allClaim-desk"}>
                  <FaFistRaised />
                </a>
              </span>
            </Tooltip>
          </RightsWrapper>

          <RightsWrapper myRight={"ArchiveDesk.view"}>
            <Tooltip title={"Archive Desk"}>
              <span className={styles.deskIcons}>
                <a href={"/desk/allArchive-desk"}>
                  <FaArchive />
                </a>
              </span>
            </Tooltip>
          </RightsWrapper>

          <RightsWrapper myRight={"DeadInquiry.view"}>
            <Tooltip title={"Dead Inquiry"}>
              <span className={styles.deskIcons}>
                <a href={"/desk/allDeadStudent-list"}>
                  <FaBookDead />
                </a>
              </span>
            </Tooltip>
          </RightsWrapper>

          <RightsWrapper myRight={"Appointment.add"}>
            <Tooltip title={"Add Appointment"}>
              <span className={styles.deskIcons}>
                <a href={"/appointment"}>
                  <FaCalendarPlus />
                </a>
              </span>
            </Tooltip>
          </RightsWrapper>

          <RightsWrapper myRight={"Task.add"}>
            <Tooltip title={"Add Task"}>
              <span className={styles.deskIcons}>
                <a href={"/task"}>
                  <FaClipboardList />
                </a>
              </span>
            </Tooltip>
          </RightsWrapper>

          <RightsWrapper myRight={"Student.view"}>
            <Tooltip title={"Students List"}>
              <span className={styles.deskIcons}>
                <a href={"/allStudents"}>
                  <FaUserGraduate />
                </a>
              </span>
            </Tooltip>
          </RightsWrapper>

          <RightsWrapper myRight={"financeClaims.view"}>
            <Tooltip title={"Students Record Sheet"}>
              <span className={styles.deskIcons}>
                <a href={"/desk/finance-claims"}>
                  <FaRegFileExcel />
                </a>
              </span>
            </Tooltip>
          </RightsWrapper>
          <RightsWrapper myRight={"DeadCounsellingDesk.view"}>
            <Tooltip title={"Dead Counselling Desk"}>
              <span className={styles.deskIcons}>
                <a href={"/desk/dead-counselling-desk"}>
                  <FaUserTimes />
                </a>
              </span>
            </Tooltip>
          </RightsWrapper>
        </span>

        <Drawer
          title={`New Student(s):- ${totalNewFiles}`}
          placement="right"
          closable={true}
          onClose={() => {
            this.setState({
              openApplicationDrawar: false,
            });
          }}
          visible={this.state.openApplicationDrawar}
          width={1000}
        >
          <TableComp
            ref={this.tableOverallReport}
            columns={columnOverallReport}
            dataSource={newFilesData}
            extraProps={{ scroll: { x: 900 } }}
            pagination={{
              showSizeChanger: false,
              defaultPageSize: '20',
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Drawer>
        <Drawer
          title={`New Incentive Invoice(s):- ${totalNewIncentiveFiles}`}
          placement="right"
          closable={true}
          onClose={() => {
            this.setState({
              openIncentiveInvoiceDrawer: false,
            });
          }}
          visible={this.state.openIncentiveInvoiceDrawer}
          width={900}
        >
          <TableComp
            ref={this.tableIncentiveReport}
            columns={incentiveInvoiceColumns}
            dataSource={newIncentivesFilesData}
            pagination={{
              showSizeChanger: false,
              defaultPageSize: '20',
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Drawer>

        {/* Move Archive Desk Requests Start */}

        <Drawer
          title={`Due Invoices (Students):- ${dueInvoicesList.length}`}
          placement="right"
          closable={true}
          onClose={() => {
            this.setState({
              showDueInvoicesDrawer: false,
            });
          }}
          visible={this.state.showDueInvoicesDrawer}
          width={1000}
        >
          <TableComp
            ref={this.dueInvoicesDrawer}
            columns={dueInvoicesColumns}
            dataSource={dueInvoicesList}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 50,
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Drawer>

        <Drawer
          title={`Move To Archive Desk Requests:- ${totalNewMoveArchiveRequest}`}
          placement="right"
          closable={true}
          onClose={() => {
            this.setState({
              openMoveToArchiveDeskDrawer: false,
            });
          }}
          visible={this.state.openMoveToArchiveDeskDrawer}
          width={1200}
        >
          <TableComp
            ref={this.tableArchiveRequests}
            columns={moveArchiveColumns}
            dataSource={newMoveArchiveRequestsData}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 50,
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
          {/* <TableComp
            ref={this.tableArchiveRequests}
            columns={moveArchiveColumns}
            dataSource={newMoveArchiveRequestsData}
            pagination={{
              showSizeChanger: false,
              defaultPageSize: 20,
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          /> */}
        </Drawer>

        {/* Move Archive Desk Requests End */}

        <Drawer
          title={`Pending Invoice Followups:- ${totalPaymentFollowUps}`}
          placement="right"
          closable={true}
          onClose={() => {
            this.setState({
              showPaymentFollowupDrawer: false,
            });
          }}
          visible={this.state.showPaymentFollowupDrawer}
          width={1000}
        >
          {
            this.state.showFollowUp ? (
              <ListFollowUps invoiceObj={invoiceObj} onClose={this.closeFollowUp} />
            )
              : null
          }
          <TableComp
            ref={this.tableInvoiceFollowUp}
            columns={paymentFollowupsColumns}
            dataSource={totalPaymentFollowUpsData}
            pagination={{
              showSizeChanger: false,
              defaultPageSize: '20',
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Drawer>

        {/* Update Payment Details Drawer */}
        <Drawer
          title={`Update Account Payment Requests:- ${this.state.totalUpdationRequests}`}
          placement="right"
          closable={true}
          onClose={() => {
            this.setState({
              openUpdatePaymentDrawer: false,
            });
          }}
          visible={this.state.openUpdatePaymentDrawer}
          width={1000}
        >

          <TableComp
            ref={this.updatePaymentRequests}
            columns={updatePaymentColumns}
            dataSource={this.state.paymentUpdationsData}
            pagination={{
              showSizeChanger: false,
              defaultPageSize: '20',
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Drawer>

        {/* Annoucements Drawer Start */}
        <Drawer
          title={`New Annoucements:- ${this.state.totalAnnoucements}`}
          placement="right"
          closable={true}
          onClose={() => {
            this.setState({
              showAnnoucmentDrawer: false,
            });
          }}
          visible={this.state.showAnnoucmentDrawer}
          width={1000}
        >

          <TableComp
            ref={this.annoucmentsDrawer}
            columns={annoucementColumns}
            dataSource={this.state.annoucementData}
            pagination={{
              showSizeChanger: false,
              defaultPageSize: '20',
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Drawer>


        {/* Annoucements Drawer End */}

        <Drawer
          title={`Branch Invoice Requests:- ${this.state.branchInvoiceDetails.length}`}
          placement="right"
          closable={true}
          onClose={() => {
            this.setState({
              showBranchInvoiceStatusDrawer: false,
            });
          }}
          visible={this.state.showBranchInvoiceStatusDrawer}
          width={600}
        >

          <TableComp
            ref={this.branchPaymentStatusDrawer}
            columns={branchInvoiceColumns}
            dataSource={this.state.branchInvoiceDetails}
            pagination={{
              showSizeChanger: false,
              defaultPageSize: '20',
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Drawer>


        <RightContent {...this.props} />
      </div>
    );
  }
}
